<template>
    <div class="header">
        <div class="logo"></div>

        <comp-message></comp-message>

        <p class="userName" @click="show = true">账号：{{ nickname }}</p>
        <span class="exit" @click="logout">退出</span>

        <div v-show="show" class="common-popup-bg">
            <div class="common-popup">
                <h3>编辑信息</h3>
                <el-form ref="ruleForm_userInfo" class="form" :model="form" :rules="rules" size="medium">
                    <el-form-item label="用户账号：">
                        {{ nickname }}
                    </el-form-item>
                    <el-form-item label="修改密码：" prop="password">
                        <el-input v-model="form.password" type="password" placeholder="6-16位英文或数字或者“!@#$%^&*.”" />
                    </el-form-item>
                    <el-form-item label="密码确认：" prop="repeatPassword">
                        <el-input v-model="form.repeatPassword" type="password" placeholder="请输入" />
                    </el-form-item>
                </el-form>
                <footer>
                    <el-button size="small" @click="close('ruleForm_userInfo')">取消</el-button>
                    <el-button size="small" type="primary" @click="submitForm('ruleForm_userInfo')">保存</el-button>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
import compMessage from './compMessage'
import router from '../../router'
export default {
    components: {
        compMessage
    },
    data() {
        return {
            show: false,
            form: {
                password: '',
                repeatPassword: ''
            },
            rules: {
                password: [
                    {
                        validator: (rule, value, callback) => {
                            if (value.length && !/^[A-Za-z0-9!@#$%^&*.]{6,16}$/.test(value)) {
                                callback(new Error('6-16位英文或数字或者“!@#$%^&*.”'));
                            } else {
                                callback();
                            }
                        }, trigger: 'blur'
                    }
                ],
                repeatPassword: [
                    {
                        validator: (rule, value, callback) => {
                            if (value !== this.form.password) {
                                callback(new Error('两次输入密码不一致!'));
                            } else {
                                callback();
                            }
                        }, trigger: 'blur'
                    }
                ],
            }
        }
    },
    computed: {
        nickname() {
            return localStorage.getItem('nickname')
        }
    },
    mounted() {
        var self = this;
        window.addEventListener('beforeunload', event => {
            self.logout();
            router.replace('/login');
            localStorage.clear();
            location.reload()
        });

    },
    methods: {
        ...mapActions('login', ['logout', 'getMenus']),
        ...mapActions('authUsers', ['updatePassword']),
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let params = Object.assign({}, this.form, {
                        password: window.btoa(this.form.password),
                        repeatPassword: window.btoa(this.form.repeatPassword)
                    });
                    this.updatePassword(params).then(() => {
                        this.$message.success('修改成功');
                        this.close(formName)
                    });
                }
            });
        },
        close(formName) {
            this.$refs[formName].resetFields();
            this.show = false;
        }
    }
}
</script>
<style lang="scss" scoped>
.header {
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0 20px;
    color: #fff;
    background-color: $theme-color;
}

.logo {
    flex: 1;
    font-size: 24px;
    font-weight: bold;
}

.userName {
    padding-right: 100px;
    cursor: pointer;

    &:hover {
        color: $color-black1;
        transform: translateY(1px);
    }
}

.exit {
    cursor: pointer;

    &:hover {
        color: $color-black1;
        transform: translateY(1px);
    }
}

.form {
    padding-top: 20px;

    :global(.el-input) {
        width: 280px;
    }

    .mobile {
        :global(.el-input:first-of-type) {
            width: 70px;
        }

        :global(.el-input:last-of-type) {
            width: 200px;
            margin-left: 10px;
        }
    }

    :global(.el-form-item) {
        padding: 0 40px 0 30px;
    }

    :global(.el-form-item__label) {
        display: inline-block;
        width: 100px;
    }

    :global(.el-form-item__content) {
        display: inline-block;
    }
}
</style>